// SdsHelpLine.js
// "Can't find an SDS?" help: a website to search, up to two phone numbers to call and the shared 3E login,
// from the SDS_HELP_* and EWI_SDS_USER* server settings.

import React, { useState } from "react";
import styles from "./SdsLookupSection.module.css";

const HTTP_URL_RE = /^https?:\/\//i;
const MASKED_PASSWORD = "••••••••";

// tel: links keep digits and a leading + only; an extension is dropped so "(800) 555-0100 ext 2" dials the main number
const telHref = (phone) => `tel:${phone.split(/\s*(?:ext\.?|x)\s*\d/i)[0].replace(/(?!^\+)\D/g, "")}`;

/**
 * @param {object|null} sdsStatus - /api/sds/status; reads help_url, help_label, help_phone, help_phone_alt,
 *   help_login_user, help_login_password
 */
export const SdsHelpLine = ({ sdsStatus }) => {
  const [showPassword, setShowPassword] = useState(false);
  const url = HTTP_URL_RE.test(sdsStatus?.help_url || "") ? sdsStatus.help_url : null;
  // The alternate number becomes the main one when only it is set
  const [phone, altPhone] = [sdsStatus?.help_phone, sdsStatus?.help_phone_alt]
    .map((value) => (value || "").trim())
    .filter(Boolean);
  const loginUser = (sdsStatus?.help_login_user || "").trim() || null;
  const loginPassword = sdsStatus?.help_login_password || null;
  if (!url && !phone && !loginUser) return null;
  const label = sdsStatus?.help_label || "SDS search website";

  return (
    <div className={styles.helpLine} data-testid="sds-help-line">
      <span className={styles.helpLead}>Can&apos;t find an SDS?</span>
      {url && (
        <a className={styles.helpLink} href={url} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      )}
      {phone && (
        <a className={styles.helpLink} href={telHref(phone)}>
          Call {phone}
        </a>
      )}
      {altPhone && (
        <span className={styles.helpAlt}>
          or
          <a className={styles.helpLink} href={telHref(altPhone)} aria-label={`Call ${altPhone}`}>
            {altPhone}
          </a>
        </span>
      )}
      {loginUser && (
        <div className={styles.helpLogin} data-testid="sds-help-login">
          <span className={styles.helpLead}>3E login:</span>
          <span>
            User <span className={styles.helpCredential}>{loginUser}</span>
          </span>
          {loginPassword && (
            <span className={styles.helpPassword}>
              Password{" "}
              <span className={styles.helpCredential} data-testid="sds-help-password">
                {showPassword ? loginPassword : MASKED_PASSWORD}
              </span>
              <button
                type="button"
                className={styles.helpToggle}
                aria-pressed={showPassword}
                onClick={() => setShowPassword((shown) => !shown)}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};
